<template>
    <span>
        {{location.location_type.display_name}}
        <span v-if="!hideArrow">&rarr;</span>
        <router-link v-if="hasLocationPermission(location.location_type.identifier, location.identifier, 'locations.contactinfo.edit')"
                     :to="getRoute"
                     v-text="location.display_name"
         />
        <span v-else>{{location.display_name}}</span>
    </span>
</template>

<script>
export default {
    name: "LocationLink",

    props: {
        location: {required: true, type: Object},
        hideArrow: {default: false, type: Boolean},
    },

    data() {
        return {}
    },

    computed: {
        getRoute() {
            return {
                name: 'locationEditContactInfo',
                params:{
                    locationTypeIdentifier: this.location.location_type.identifier,
                    locationIdentifier: this.location.identifier,
                }
            }
        },
    },
    methods: {},
}
</script>

<style scoped>

</style>
